import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import cx from 'classnames'

import LinkButton from 'components/LinkButton'

/* eslint-disable react/no-danger */
const TwoColumn = ({
  id,
  heading,
  subheading,
  paragraph,
  isBoxed,
  isSingleColumn,
  columns,
  numberedList,
  hasPaddingTop,
  hasPaddingBottom,
  hasNoPaddingTop,
  hasNoPaddingBottom,
  unorderedList,
  trailingParagraph,
  link,
}) => {
  const { text: headingText, size } = heading || {}
  const { buttonText, text: linkText, route } = link || {}

  function renderUnorderedList(unorderList) {
    if (unorderList) {
      return (
        <ul className="two-column__unordered-list">
          {map(unorderList, (text, colIndex) => (
            <li
              key={`column-numbered-list_${colIndex}`}
              dangerouslySetInnerHTML={{ __html: text }}
            ></li>
          ))}
        </ul>
      )
    }
    return null
  }

  return (
    <div
      id={id}
      className={cx('sem__two-column', {
        '--is-single-column': isSingleColumn,
        '--has-padding-top': hasPaddingTop,
        '--has-padding-bottom': hasPaddingBottom,
        '--has-no-padding-top': hasNoPaddingTop,
        '--has-no-padding-bottom': hasNoPaddingBottom,
      })}
    >
      {subheading && <p className="two-column__subheading">{subheading}</p>}
      {headingText && (
        <h2 className={cx('two-column__heading', `--${size}`)}>
          {headingText}
        </h2>
      )}
      {paragraph &&
        map(paragraph, (paragraphText, index) => (
          <p
            key={`two-column-paragraph_${index}`}
            className="two-column__paragraph"
            dangerouslySetInnerHTML={{ __html: paragraphText }}
          />
        ))}
      <div className="two-column__columns">
        {map(columns, (column, index) => (
          <Fragment key={`columns-${index}`}>
            {column.isBoxed && <div className="two-column__column-break" />}
            <div
              key={`columns-${index}`}
              className={cx('two-column__column', {
                '--boxed': isBoxed || column.isBoxed,
                '--is-one-row': columns.length === 2,
              })}
            >
              {column.heading && !column.link && (
                <h3 className="two-column__column-heading">{column.heading}</h3>
              )}
              {column.link && (
                <a className="two-column__column-link" href={column.link}>
                  <h3 className="two-column__column-heading">
                    {column.heading}
                  </h3>
                </a>
              )}
              {column.description &&
                map(column.description, (text, colIndex) => (
                  <p
                    key={`column-description_${colIndex}`}
                    className="two-column__description"
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                ))}
              {renderUnorderedList(column.unorderedList)}
            </div>
          </Fragment>
        ))}
        {numberedList && (
          <ol className="two-column__numbered-list">
            {map(numberedList, (text, colIndex) => (
              <li key={`column-numbered-list_${colIndex}`}>{text}</li>
            ))}
          </ol>
        )}
        {renderUnorderedList(unorderedList)}
      </div>
      {trailingParagraph && (
        <p
          className="two-column__paragraph --trailing"
          dangerouslySetInnerHTML={{ __html: trailingParagraph }}
        />
      )}
      {link && (
        <div className="two-column__link">
          <p className="two-column__link-text">{linkText}</p>
          <LinkButton text={buttonText} route={route} />
        </div>
      )}
    </div>
  )
}
/* eslint-enable react/no-danger */

// TwoColumn.defaultProps = sectionData

TwoColumn.propTypes = {
  id: PropTypes.string,
  hasPaddingBottom: PropTypes.bool,
  hasPaddingTop: PropTypes.bool,
  hasNoPaddingBottom: PropTypes.bool,
  hasNoPaddingTop: PropTypes.bool,
  heading: PropTypes.shape({
    text: PropTypes.string,
    size: PropTypes.string,
  }),
  subheading: PropTypes.string,
  paragraph: PropTypes.arrayOf(PropTypes.string),
  isBoxed: PropTypes.bool,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.arrayOf(PropTypes.string),
      link: PropTypes.string,
      isBoxed: PropTypes.bool,
    }),
  ),
  link: PropTypes.shape({
    text: PropTypes.string,
    route: PropTypes.string,
    buttonText: PropTypes.string,
  }),
  numberedList: PropTypes.arrayOf(PropTypes.string),
  unorderedList: PropTypes.arrayOf(PropTypes.string),
  trailingParagraph: PropTypes.string,
  isSingleColumn: PropTypes.bool,
}

export default TwoColumn
